import { Injectable } from '@angular/core'
import { TaginVarit } from 'app/_jaettu-lemonator/model/asiakas'

@Injectable()
export class TagiVaritService {
  readonly kaikkiVarit: TaginVarit[] = [
    { varikoodi: '#3a8a5b', taustavari: '#e3f0e8' },
    { varikoodi: '#6f54c7', taustavari: '#ebe6f7' },
    { varikoodi: '#c47429', taustavari: '#f9ead6' },
    { varikoodi: '#2f7d97', taustavari: '#dceef3' },
    { varikoodi: '#2d9a5e', taustavari: '#dff4e7' },
    { varikoodi: '#8a4fc4', taustavari: '#f0e7f7' },
    { varikoodi: '#d67c29', taustavari: '#faeedd' },
    { varikoodi: '#a3861d', taustavari: '#f6f0d4' },
    { varikoodi: '#7a9a24', taustavari: '#eff4da' },
    { varikoodi: '#1f9d8a', taustavari: '#dbf2ee' },
    { varikoodi: '#3763c4', taustavari: '#e3eafa' },
    { varikoodi: '#c93a8c', taustavari: '#fae4f0' },
    { varikoodi: '#d23a6c', taustavari: '#fbe4ec' },
    { varikoodi: '#96653a', taustavari: '#f3eae1' },
    { varikoodi: '#c7a500', taustavari: '#fbf5d2' },
    { varikoodi: '#d84f90', taustavari: '#fce7f2' },
    { varikoodi: '#b04a6e', taustavari: '#f7e6ec' },
    { varikoodi: '#b25fb2', taustavari: '#f5e8f6' },
  ]

  annaVahitenKaytettyVari(kaytetytVarikoodit: string[]): TaginVarit {
    const varit = this.kaikkiVarit.map(vari => ({
      vari: vari,
      kayttomaara: kaytetytVarikoodit.filter(varikoodi => varikoodi === vari.varikoodi).length,
    }))
    varit.sort((a, b) => a.kayttomaara - b.kayttomaara)
    return varit[0].vari
  }
}
